import React, { FC } from 'react';
import { Layer, Image } from 'react-konva';

interface ImageLayerProps {
  width: number;
  height: number;
  image?: HTMLImageElement;
}

const ImageLayer: FC<ImageLayerProps> = ({ image, width, height }) => {
  return (
    <Layer id="background-image">
      <Image image={image} width={width} height={height} />
    </Layer>
  );
};

export default ImageLayer;
